module.exports = __webpack_public_path__ + "static/media/logo-symbol-white.136f8ea1.svg";